import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import style from './style.module.css';
import React, { useState } from 'react';
import Select, { ActionMeta, SingleValue } from 'react-select';

interface Option {
  value: string;
  label: string | React.ReactNode;
}
interface InputSelectProps {
  placeholder?: string;
  options: Option[];
  onOptionSelect?: (option: Option) => void;
  onOptionDeselect?: (option: Option) => void;
  onChange?: (value: string) => void;
  defaultValue?: string;
  name?: string;
  value?: string;
}

const CustomSelect = ({
  placeholder,
  options,
  onOptionSelect,
  onOptionDeselect,
  onChange,
  defaultValue,
  value,
  name,
}: InputSelectProps) => {
  const [selectedOption, setSelectedOption] = useState<Option>();

  const handleChange = (selected: SingleValue<Option>) => {
    if (selectedOption && onOptionDeselect) {
      onOptionDeselect(selectedOption);
    }

    if (selected && onOptionSelect) {
      onOptionSelect(selected);
    }

    if (onChange) {
      onChange(selected?.value || '');
    }

    setSelectedOption(selected || null);
  };

  return (
    <div style={{ width: 'fit-content' }}>
      <Select
        classNames={{
          control: () => style.selectControl,
          menu: () => style.selectMenu,
        }}
        components={{ DropdownIndicator: null }}
        name={name}
        placeholder={placeholder}
        onChange={handleChange}
        options={options}
        defaultValue={options.find((option) => option.value === defaultValue)}
        value={options.find((option) => option.value === value)}
      />
    </div>
  );
};

export default CustomSelect;
